// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"434":"2956360c","540":"463cef8a"}[chunkId] + ".chunk.js";
};